// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__pVODW","wrapper":"Modal_wrapper__572ZF","inner":"Modal_inner__JnTfb","modal":"Modal_modal__m40Sr","closeBtn":"Modal_closeBtn__AI36f"};